export enum TimelineStage {
  NON_BINDING_OFFER = 'NON_BINDING_OFFER',
  BINDING_OFFER = 'BINDING_OFFER',
  CONTRACTING = 'CONTRACTING',
  COMPLETE = 'COMPLETE',
}
export const timelineStageToLabel = {
  [TimelineStage.BINDING_OFFER]: 'Binding Offer',
  [TimelineStage.NON_BINDING_OFFER]: 'Non-Binding Offer',
  [TimelineStage.CONTRACTING]: 'Contracting',
  [TimelineStage.COMPLETE]: 'Complete',
};
